import { createContext, useContext } from "react";
import type { StaffingIssue, Suggestion } from "@/utils/autoStaffing";
import type { BaseRequest, Nurse, OpenShiftRequest, ReplaceShiftRequest } from "@/utils/models";
import type { ApproveRequestOutcome } from "./RequestUtilsProvider";

type RequestUtilsContextType = {
	approveAddRequest: (nurseId: number, request: OpenShiftRequest | ReplaceShiftRequest, location?: string) => Promise<void>;
	recomendationFromRequests: (request: OpenShiftRequest | ReplaceShiftRequest) => StaffingIssue;
	suggestionFromRequest: (request: BaseRequest, nurse: Nurse | undefined) => Suggestion[];
	/** Resolves once the writes and the requests refresh are done, with what the approval did. */
	approveRequest: (request: OpenShiftRequest | ReplaceShiftRequest, nurseId: number, location?: string) => Promise<ApproveRequestOutcome>;
	isPartialShift: (request: BaseRequest, nurseId: number) => boolean;
	isApproveAddRequestLoading: boolean;
};

export const RequestUtilsContext = createContext<RequestUtilsContextType | undefined>(undefined);

export const useRequestUtils = () => {
	const context = useContext(RequestUtilsContext);
	if (!context) {
		throw new Error("useRequestUtils must be used within a RequestUtilsProvider");
	}
	return context;
};
